export const styles = theme => ({
    button: {
        margin: '8px',
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: '8px'
    },
    formControl: {
        minWidth: '194px'
    },
    marginLeft :{
        marginLeft: '8px'
    },withoutLabel: {
        marginTop: '8px' * 3
    }, textField: {
        flexBasis: 200
    }, topBarButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }, toggleMapButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
        width: '817px'
    }, plainWhiteButton: {
        color: '#000',
        borderWidth: 'thin',
        backgroundColor: '#ffffff',
        width: '200px'
    }, clearPolygonButton: {
        color: '#000',
        borderWidth: 'thin',
        '&:hover': {
          backgroundColor: '#EE5353',
          // borderColor: '#B2B2B2',
        },
        // backgroundColor: '#EE5353',
    }, mapContainer: {
        backgroundColor: '#ebf0f4',
        borderStyle: 'solid',
        borderColor:'#4589b6',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }, metOptionsContainer: {
        width: '815px',
    }, toggleAdvancedOptionsButton: {
        // color: '#212121',
        // borderColor: '#878787',
        // borderWidth: 'thin',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#EDEDED',
          borderColor: '#B2B2B2',
        },
        width: '817px'
    }
    , advancedOptionsContainer: {
        // backgroundColor: '#EDEDED',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderColor:'#B2B2B2',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }
});

export function validateRequestBody(formInputs) {
    let regex = new RegExp(/^[\w-\s]+$/)
    let mcErrorregex = regex.test(formInputs['modelDescription'])
    console.log(mcErrorregex)

    if (!mcErrorregex){
        return "Project Description only allows the special characters: spaces, hyphens, and underscores."
    }
    
    if (parseInt(formInputs['e_sn'].split(",")[0]) < 50){
        return "Increase the outer domain e_sn to a size of at least 50"
    }else if (parseInt(formInputs['e_we'].split(",")[0]) < 50){
        return "Increase the outer domain e_we to a size of at least 50" 
    }

    if (formInputs["runOption"] === "setup"){
        if (!formInputs['max_dom'] || !formInputs['parent_id'] || !formInputs['parent_grid_ratio'] ||
            !formInputs['i_parent_start'] || !formInputs['j_parent_start'] || !formInputs['e_we'] ||
            !formInputs['e_sn'] || !formInputs['dx'] || !formInputs['dy'] || !formInputs['map_proj'] ||
            !formInputs['ref_lat'] || !formInputs['ref_lon'] || !formInputs['truelat1'] ||
            !formInputs['truelat2'] || !formInputs['stand_lon']){            
                return 'Please provide a modeling domain'
        }else if (!formInputs['start_date']){
            return "Please choose a start date."
        }
     
    }else if (formInputs["runOption"] === "BulkRuns"){
        if (!formInputs["previousProjSucc"]){
            return "Please select a previous project."
        }
    }

    // start_date
    if (formInputs["start_date"] >= formInputs["end_date"]){
        console.log(formInputs["end_date"] - formInputs["start_date"])
        return "Please select a valid end date."
    }else if (formInputs["start_date"] > "2025-09-30" ){
        return "Please select a start date before 2025-09-30"
    }else if (formInputs["end_date"] > "2025-09-30" ){
        return "Please select a end date before 2025-09-30"
    }
    // end_date
    // check on number of tokens required based on time range and option
    
}

export function translateRequestBody(formInputs) {
    let requestBody = {
        "DESCRIPTION": formInputs["modelDescription"]+"_"+formInputs["runOption"],
        "MODEL": formInputs["model"],
        "WRFV": formInputs["wrfV"],
        "RUN_OPT": formInputs["runOption"],
        "START_DATE":formInputs["start_date"],
        "END_DATE":formInputs["end_date"],
        "PHYSICS_OPTION": formInputs["physics_option"],
        "BOUNDARY_MET": formInputs["boundary_met"],
        "MAX_DOM": formInputs["max_dom"],
        "PARENT_ID": formInputs["parent_id"],
        "PARENT_GRID_RATIO": formInputs["parent_grid_ratio"],
        "I_PARENT_START": formInputs["i_parent_start"],
        "J_PARENT_START": formInputs["j_parent_start"],
        "E_WE": formInputs["e_we"],
        "E_SN": formInputs["e_sn"],
        "DX": formInputs["dx"],
        "DY": formInputs["dy"],
        "MAP_PROJ": "lambert",
        "REF_LAT": formInputs["ref_lat"],
        "REF_LON": formInputs["ref_lon"],
        "TRUELAT1": formInputs["truelat1"],
        "TRUELAT2": formInputs["truelat2"],
        "STAND_LON": formInputs["stand_lon"],
        "SETUP_ID": formInputs["previousProjSucc"],
        "PROC": formInputs["computeOption"].split(":")[0],
        "RAM": formInputs["computeOption"].split(":")[1],
    };

    return requestBody
}
